import React from "react";
import { Main } from "./settings.styled";


export default function settings() {

  return (
    <Main>
    <h1>
      it works 
    </h1>
   
    </Main>
    
  );
}
